import RestClient from './RestClient';
import { Task } from '../../models';
import store from '../../redux';
import moment from 'moment';
import { getRequestInstanceQueryValue } from '../requestInstance';

class Tasks extends RestClient {
    constructor() {
        super({
            "model": Task,
            "entryPoint": "task",
            "resource": "task"
        });
    }

    icsLink(params) {
        const link = new URL(`${this.baseUrl}/task/ics`);
        const user = store.getState().auth.user;
        if (user?.api_key)
            link.searchParams.append('x-api-key', user.api_key);

        const tkt_instance = getRequestInstanceQueryValue();
        if (tkt_instance)
            link.searchParams.append('tkt_instance', tkt_instance);

        if (!params)
            return link.href;

        ['screening_id', 'phase_id', 'period_id', 'sector_id', 'sector_id_in', 'activity_id', 'user_id', 'status', 'status_in', 'without_shift'].forEach((key) => {
            if (params[key])
                link.searchParams.append(key, params[key]);
        });
        ['start_at_lte', 'start_at_gte', 'stop_at_lte', 'stop_at_gte'].forEach((key) => {
            if (params[key])
                link.searchParams.append(key, moment(params[key]).toISOString());
        });

        return link.href;
    }

    list(params) {
        params = params || {};
        let url = '/task/list';
        ['screening_id', 'phase_id', 'period_id', 'sector_id', 'sector_id_in', 'activity_id', 'user_id', 'status', 'status_in', 'without_shift'].forEach((key) => {
            if (params[key])
                url += `/${key}/${params[key]}`;
        });
        ['start_at_lte', 'start_at_gte', 'stop_at_lte', 'stop_at_gte'].forEach((key) => {
            if (params[key])
                url += `/${key}/${moment(params[key]).toISOString()}`;
        });

        let fields = params.fields;
        if (!Array.isArray(fields))
            fields = [];
        const query = {};
        const normalized_fields = fields
            .map((f) => String(f).trim())
            .filter((f) => f.length > 0 && /^[\w.]+$/.test(f));
        if (normalized_fields.length > 0)
            query.fields = normalized_fields.join(',');

        return this.GET(url, query)
            .then(response => response.json())
            .then(json => {
                if (json.tasks)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    assign(task_id, user_id) {
        let url = `/task/assign/id/${task_id}`;
        return this.PUT(url, { 'user_id': user_id })
            .then(response => response.json())
            .then(json => {
                if (json.task)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    change_status(task_id, status) {
        let url = `/task/change_status/id/${task_id}`;
        return this.PUT(url, { 'status': status })
            .then(response => response.json())
            .then(json => {
                if (json.task)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    accept(task_id) {
        let url = `/task/accept/id/${task_id}`;
        return this.PUT(url)
            .then(response => response.json())
            .then(json => {
                if (json.task)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    claim(task_id) {
        let url = `/task/claim/id/${task_id}`;
        return this.PUT(url)
            .then(response => response.json())
            .then(json => {
                if (json.task)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    refuse(task_id) {
        let url = `/task/refuse/id/${task_id}`;
        return this.PUT(url)
            .then(response => response.json())
            .then(json => {
                if (json.task)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    renounce(task_id, msg) {
        let url = `/task/renounce/id/${task_id}`;
        return this.PUT(url, {msg: msg})
            .then(response => response.json())
            .then(json => {
                if (json.task)
                    return json;
                throw new Error(json.flash.error);
            });
    }
}

const TasksApi = new Tasks();

export default TasksApi;
